import { AthleteOverviewPageView } from "@/components/athlete-overview-page/athlete-overview-page-view";
import { AthleteProfileSearchPage } from "@/pages/athlete-profile-search-page";
import { CategoryPage } from "@/pages/category-page";
import { ErrorPage } from "@/pages/error-page";
import { TerminEventSearchPage } from "@/pages/termin-event-search-page";
import SearchPage from "../../Features/Search/React/SearchPage";
import {CourseSearchPage} from "@/pages/course-search-page";
import { AthleteProfilePage } from "@/pages/athlete-profile-page";

export default {
    AthleteProfileSearchPage,
    AthleteOverviewPageView,
    CourseSearchPage,
    TerminEventSearchPage,
    CategoryPage,
    ErrorPage,
    SearchPage,
    AthleteProfilePage,
};